import React from "react";
import styled from "styled-components";

import Device from "@/utils/device";
import colours from "../../../utils/colours";

type StyleProps = {
  image: string;
};

type SpeakerImageProps = {
  imageSrc: string;
  jobTitle: string;
  name: string;
};

const SpeakerImage: React.FC<SpeakerImageProps> = (props) => {
  return (
    <S.BrandCard image={props.imageSrc}>
      <S.TitleContainer>
        <S.Title>{props.name}</S.Title>
        <S.Line />
        <S.JobTitle>{props.jobTitle}</S.JobTitle>
      </S.TitleContainer>
    </S.BrandCard>
  );
};

const S = () => {};

S.BrandCard = styled.li<StyleProps>`
  position: relative;
  flex-shrink: 0;
  list-style-type: none;
  height: 100%;
  width: 100%;
  background-image: url(${(p) => p.image});
  background-size: 110%;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  transition: all 0.2s;
  aspect-ratio: 1;

  @supports not (aspect-ratio: 1) {
    &::before {
      float: left;
      padding-top: 100%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }
`;

S.TitleContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 0 5%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  opacity: 0;
  border-radius: 50%;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
`;

S.Title = styled.p`
  position: relative;
  width: 100%;
  text-align: center;
  font-family:
    Roxborough CF,
    sans-serif;
  font-size: 1rem;
  font-weight: 100;
  color: ${colours.shell};

  @media ${Device.mobile} {
    font-size: 1.2rem;
  }

  @media ${Device.desktop} {
    font-size: 2.2rem;
  }
`;

S.Line = styled.div`
  background: ${colours.marketingYellow};
  height: 2px;
  width: 50%;
`;

S.JobTitle = styled.p`
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 0.5rem;
  color: ${colours.shell};

  @media ${Device.mobile} {
    font-size: 0.6rem;
  }

  @media ${Device.desktop} {
    font-size: 1.3rem;
  }
`;

export default SpeakerImage;
